import { NgModule } from '@angular/core';
import { ReviewsDataAccessModule } from '@reviews/data-access';
import { ReviewsFeatureModule } from '@reviews/feature';
import { ReviewsUtilsModule } from '@reviews/utils';

@NgModule({
  imports: [ReviewsDataAccessModule, ReviewsFeatureModule, ReviewsUtilsModule],
})
export class ReviewsShellModule {}
